import React, {useEffect} from "react";
import useStyles from "../styles";
import {Checkbox, FormControlLabel, TextField} from "@material-ui/core";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PaymentIcon from '@material-ui/icons/Payment';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import {useDispatch} from "react-redux";
import {ADD_PAYMENT} from "@cabinet-packages/redux/actions/actionsTypes";

const CheckboxWrapper = ({setChange, useStateFields}) => {
    const cl = useStyles();
    const dispatch = useDispatch();
    const [stateField, setStateField] = useStateFields;

    const handleChange = (e) => {
        e.persist();
        Object.keys(stateField).map(el => {
            setStateField(prevState => ({
                ...prevState,
                [el]: {
                    checked: false,
                    value: ''
                },
                [e.target.name]: {
                    ...prevState[e.target.name],
                    checked: e.target.checked,
                    value: e.target.checked ? prevState[e.target.name].value : ''
                },
            }))
        });
    }

    useEffect(() => {
        Object.keys(stateField).map(el => {
            if (stateField[el].checked) {
                dispatch({
                    type: ADD_PAYMENT,
                    payload: {
                        name: stateField[el].name,
                        data: stateField[el],
                    },
                });
            }
        })
    }, [stateField])

    const handleChangeTextField = (e) => {
        e.persist();

        setStateField(prevState => ({
            ...prevState,
            [e.target.name]: {...prevState[e.target.name], value: e.target.value},
        }));
    }

    return (<div className={cl.rootCheckboxWrapper}>
        <div className={cl.wrapperFormControl}>
            <FormControlLabel
                control={<Checkbox
                    className={cl.checkbox}
                    checked={stateField.checkedCash.checked}
                    onChange={handleChange}
                    name='checkedCash'
                />}
                label={<div className={cl.checkboxLabelWrapper}>
                    <AttachMoneyIcon/> <p>Готівка</p>
                </div>}
            />
            {stateField.checkedCash.checked && <TextField
                className={cl.textField}
                fullWidth
                InputProps={{
                    endAdornment: <></>
                }}
                type="number"
                variant="outlined"
                placeholder="Сума оплати готівкою"
                multiline
                name='checkedCash'
                value={stateField.checkedCash.value}
                onChange={handleChangeTextField}
            />}
            <div className={cl.wrapperFormControlBank}>
                <FormControlLabel
                    control={<Checkbox
                        className={cl.checkbox}
                        checked={stateField.checkedBank.checked}
                        onChange={handleChange}
                        name='checkedBank'
                    />}
                    label={<div className={cl.checkboxLabelWrapper}>
                        <AccountBalanceIcon/> <p>Банк</p>
                    </div>}
                />
                {stateField.checkedBank.checked && <TextField
                    className={cl.textField}
                    fullWidth
                    autoComplete="off"
                    variant="outlined"
                    placeholder="Сума оплати"
                    multiline
                    name='checkedBank'
                    value={stateField.checkedBank.value}
                    onChange={handleChangeTextField}
                />}
            </div>
        </div>
        <div className={cl.wrapperFormControl}>
            <FormControlLabel
                control={<Checkbox
                    className={cl.checkbox}
                    checked={stateField.checkedCard.checked}
                    onChange={handleChange}
                    name='checkedCard'
                />}
                label={<div className={cl.checkboxLabelWrapper}>
                    <PaymentIcon/> <p>Картка</p>
                </div>}
            />
            {stateField.checkedCard.checked && <TextField
                className={cl.textField}
                fullWidth
                autoComplete="off"
                variant="outlined"
                placeholder="Сума оплати карткою"
                multiline
                name='checkedCard'
                value={stateField.checkedCard.value}
                onChange={handleChangeTextField}
            />
            }
        </div>
        <div className={cl.wrapperFormControl}>
            <FormControlLabel
                control={<Checkbox
                    className={cl.checkbox}
                    checked={stateField.checkedOnlineOrdering.checked}
                    onChange={handleChange}
                    name='checkedOnlineOrdering'
                />}
                label={<div className={cl.checkboxLabelWrapper}>
                    <AttachMoneyIcon/> <p>Онлайн замовлення</p>
                </div>}
            />
            {stateField.checkedOnlineOrdering.checked && <TextField
                className={cl.textField}
                fullWidth
                autoComplete="off"
                variant="outlined"
                placeholder="Сума оплати"
                multiline
                name='checkedOnlineOrdering'
                value={stateField.checkedOnlineOrdering.value}
                onChange={handleChangeTextField}
            />}
        </div>
    </div>)
}

export default CheckboxWrapper